import React from "react";

interface TextAreaProps {
  id: string;
  label?: string;
  placeholder?: string;
  rows?: number;
  error?: string;
  register?: any; // from react-hook-form
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const TextArea: React.FC<TextAreaProps> = ({
  id,
  label,
  placeholder,
  rows = 4,
  error,
  register,
  value,
  onChange,
}) => {
  return (
    <div className="mb-4 w-full">
      {label && (
        <label
          htmlFor={id}
          className="block text-sm font-medium text-gray-700 mb-1"
        >
          {label}
        </label>
      )}
      <textarea
        id={id}
        placeholder={placeholder}
        rows={rows}
        value={value}
        {...register}
        onChange={onChange}
        className={`min-w-full md:w-[450px] px-4 py-3 rounded-lg border ${
          error
            ? "border-red-500 focus:border-red-500"
            : "border-gray-300 focus:border-primary"
        } focus:outline-none resize-none`}
      />
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};

export default TextArea;
